<template>
<div>
    <header>
        <img src="@/assets/img/BGS04.png" alt />
        <div id="container">
            <div class="row">
                <router-link :to="{ name: 'BarMonth', params: { id: this.id }}">日直條圖</router-link>
                <router-link :to="{ name: 'BarYear', params: { id: this.id }}">月直條圖</router-link>
                <router-link :to="{ name: 'Interval', params: { id: this.id }}">區間</router-link>
                <span id="unit_price"></span>
            </div>
            <div class="row">
                <div id="second">
                    <div class="message" id="history">
                        <span id="historyKwh" v-if="history">歷史新高：{{ historyKwh }} kwh</span>
                        <span id="historyDate" v-if="history">{{ history.created_at.substring(0, 10) }}</span>
                    </div>
                    <div class="message" id="info">
                        <span id="infoTotalWatt" class="ulogo">{{ info.total_watt }}KW</span>
                        <span id="infoName" class="ulogo">{{ info.location + info.name }}</span>
                        <span class="ulogo">太陽能光電監控系統</span>
                        <span id="infoDate" class="dlogo">掛錶日：{{ info.date }}</span>
                        <span id="infoPrice" class="dlogo">單價： {{ info.price }} (元/度)</span>
                    </div>
                    <div class="message" id="maxWatt" v-if="max">今日高峰：{{ max.watt_dc/1000 }} kw - {{ max.created_at.substring(11, 16) }}</div>
                    <div class="message" id="maxWatt" v-else></div>
                    <div class="message" id="days" v-if="info.date">累積天數: {{ getDays(info.date) }} 天</div>
                    <div class="message" id="time">{{ getTime() }}</div>
                </div>
            </div>
            <div class="row">
                <div id="third">
                    <div id="chart"></div>
                    <div></div>
                    <div id="value">
                        <div class="value" id="inv">即時發電量：{{ watt | formatNumber }} kw</div>
                        <div class="value" id="co2">累積減碳量：{{ co2 | formatNumber }} kg</div>
                        <div class="value" id="kwh">今日度數：{{ kwh }} 度</div>
                        <div class="value">
                            <img src="@/assets/img/coinstack.gif" heigh="20px" width="20px" />
                            <span id="money">今日收入：{{ money | formatMoney }} 元</span>
                        </div>
                        <div class="value" id="totalKwh">累積度數：{{ totalKwh }} 度</div>
                        <div class="value">
                            <img src="@/assets/img/money.png" heigh="20px" width="20px" />
                            <span id="totalMoney">累積收入：{{ totalMoney | formatMoney }} 元</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div id="fourth">
                    <div class="image" v-if="pic3Url">
                        <img id="img3" class="img" v-if="pic.length > 0" :src="`${pic3Url}`" alt />
                    </div>
                    <div v-else></div>
                    <div class="image">
                        <img id="img1" class="img" v-if="pic.length > 0" :src="`${pic1Url}`" alt />
                    </div>
                    <div class="image">
                        <img id="img2" class="img" v-if="pic.length > 0" :src="`${pic2Url}`" alt />
                    </div>
                </div>
            </div>
        </div>
        <img src="@/assets/img/BGS01.png" alt />
    </header>
    <img id="footer-top" src="@/assets/img/BGS02.png" alt />
    <footer>
        ® XINYU 信宇開發
        <a href="http://www.xinyu2008.com.tw" target="_blank">監控系統</a>
    </footer>
    <span id="status">{{ status }}</span>
</div>
</template>

<script>
import Vue from "vue";
import VueYouTubeEmbed from "vue-youtube-embed";

Vue.use(VueYouTubeEmbed);

export default {
    name: "MainPic",
    data() {
        return {
            id: "",
            now: "",
            curve: "",
            increase: "",
            max: "",
            info: "",
            history: "",
            videoId: "",
            publicPath: process.env.BASE_URL,
            pic: "",
            note: "",
            pic1Url: "",
            pic2Url: "",
            pic3Url: "",
            status: "",
        };
    },
    created() {
        this.id = this.$route.params.id;

        this.$http
            .get(process.env.VUE_APP_SOALR_URL + `/api/solar/records/${this.id}`)
            .then((res) => {
                const data = res.data.data;

                var status = res.data.status;
                var message = status["message"];

                if (message === "closed" || message === "expire") {
                    this.status = "您的監控方案已到期，請盡速和您系統商連絡~! 謝謝~";
                    this.now = "";
                    this.max = "";
                    this.curve = "";
                    this.increase = "";
                } else {
                    if (message === "remind") {
                        this.status =
                            "您的監控方案將於" +
                            Math.abs(status["days"]) +
                            "天後到期，請盡速和您系統商連絡~! 謝謝~";
                    }

                    this.now = data.now;
                    this.max = data.max;
                    this.curve = data.curve;
                    this.increase = data.increase;
                }
            });

        this.$http
            .get(process.env.VUE_APP_SOALR_URL + `/api/solar/infos/${this.id}`)
            .then((res) => {
                const data = res.data;
                this.info = data.info;
                this.history = data.history;
                this.videoId = data.info.youtube;
                this.pic = data.pic;
                this.note = this.pic[0].note;
                this.pic1Url = this.pic[0].url;
                this.pic2Url = this.pic[1].url;
                this.pic3Url = this.pic[2].url;
            });
    },
    mounted() {
        this.getData();
    },
    beforeUpdate() {
        this.getCurve();
    },
    methods: {
        getData: function () {
            let my = this;
            setInterval(function () {
                const id = my.$route.params.id;

                my.$http
                    .get(process.env.VUE_APP_SOALR_URL + `/api/solar/records/${id}`)
                    .then((res) => {
                        const data = res.data.data;

                        var status = res.data.status;
                        var message = status["message"];

                        if (message === "closed" || message === "expire") {
                            my.status = "您的監控方案已到期，請盡速和您系統商連絡~! 謝謝~";
                            my.now = "";
                            my.max = "";
                            my.curve = "";
                            my.increase = "";
                        } else {
                            if (message === "remind") {
                                my.status =
                                    "您的監控方案將於" +
                                    Math.abs(status["days"]) +
                                    "天後到期，請盡速和您系統商連絡~! 謝謝~";
                            }

                            my.now = data.now;
                            my.max = data.max;
                            my.curve = data.curve;
                            my.increase = data.increase;
                        }
                    });

                my.$http
                    .get(process.env.VUE_APP_SOALR_URL + `/api/solar/infos/${id}`)
                    .then((res) => {
                        const data = res.data;
                        my.info = data.info;
                        my.pic = data.pic;
                        my.history = data.history;
                    });
            }, 30000);
        },
        getDays: function (date) {
            var now = new Date();
            var y = date.substr(0, 4);
            var m = date.substr(5, 2);
            var d = date.substr(8, 2);
            var temp = new Date(y, m - 1, d);

            return Math.floor((now - temp) / 86400000);
        },
        addZero: function (i) {
            if (i < 10) {
                i = "0" + i;
            }
            return i;
        },
        getTime: function () {
            var dt = new Date();
            return (
                dt.getFullYear() +
                "-" +
                (dt.getMonth() + 1) +
                "-" +
                dt.getDate() +
                " " +
                this.addZero(dt.getHours()) +
                ":" +
                this.addZero(dt.getMinutes())
            );
        },
        setTime: function (time) {
            var today = new Date();
            var day =
                today.getFullYear() +
                "/" +
                (today.getMonth() + 1) +
                "/" +
                today.getDate();
            return new Date(day + " " + time).getTime();
        },
        getCurve: function () {
            const my = this;
            var start = this.setTime("04:50");
            var end = this.setTime("19:50");
            var yMax = Math.ceil(parseFloat(this.info.total_watt) * 1.2);

            var points = [{
                data: my.curve,
                lines: {
                    show: true,
                    fill: true,
                },
            }, ];
            var options = {
                xaxis: {
                    mode: "time",
                    timezone: "browser",
                    timeBase: "milliseconds",
                    show: false,
                    min: start,
                    max: end,
                    autoScale: "none",
                },
                yaxis: {
                    show: false,
                    min: 0,
                    max: yMax,
                    autoScale: "none",
                },
                grid: {
                    hoverable: false,
                    borderWidth: 0,
                },
            };

            $.plot("#chart", points, options);
        },
        ready(event) {
            this.player = event.target;
        },
        playing(event) {
            // The player is playing a video.
        },
        change() {
            // when you change the value, the player will also change.
            // If you would like to change `playerVars`, please change it before you change `videoId`.
            // If `playerVars.autoplay` is 1, `loadVideoById` will be called.
            // If `playerVars.autoplay` is 0, `cueVideoById` will be called.
            this.videoId = "another video id";
        },
        stop() {
            this.player.stopVideo();
        },
        pause() {
            this.player.pauseVideo();
        },
    },
    computed: {
        co2: function () {
            return !this.now || !this.increase ?
                0 :
                (parseInt(this.now.kwh_total) +
                    parseInt(this.increase.original) -
                    parseInt(this.increase.new)) *
                0.636;
        },
        kwh: function () {
            return !this.now ? 0 : this.now.kwh_today / 1000;
        },
        watt: function () {
            return !this.now ? 0 : this.now.watt_dc / 1000;
        },
        money: function () {
            return this.kwh * this.info.price;
        },
        totalKwh: function () {
            return !this.now || !this.increase ?
                0 :
                parseInt(this.now.kwh_total) +
                parseInt(this.increase.original) -
                parseInt(this.increase.new);
        },
        totalMoney: function () {
            return this.totalKwh * this.info.price;
        },
        historyKwh: function () {
            return this.history.kwh / 1000;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/main_pic.scss";
</style>
